import { Alert, AlertTitle } from '@mui/material';
import ReactDOM from 'react-dom/client'; // updated import for React 18
import "./Alert.css"
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';


export const renderAlert = (message, severity, time, position, subHeading) => {
  const div = document.createElement('div');
  document.body.appendChild(div);

  const root = ReactDOM.createRoot(div); // Create root in React 18

  const handleClose = () => {
    root.unmount(); // Proper unmount in React 18
    div.remove();
  };

  if (time !== 'persist') {
    setTimeout(() => {
      handleClose();
    }, time || 5000);
  }

  root.render(
    <Alert
      severity={severity}
      onClose={handleClose}
      className="alertBox"
      action={
        <IconButton
          aria-label="close"
          color="inherit"
          size="small"
          onClick={handleClose}
        >
          <CloseIcon fontSize="inherit" />
        </IconButton>
      }
      style={{
        border:
          severity === 'error'
            ? '2px solid #d32f2f'
            : severity === 'success'
              ? '2px solid #2e7d32'
              : severity === 'info'
                ? '2px solid #0288d1'
                : severity === 'warning'
                  ? '2px solid #ed6c02'
                  : 'unset',
      }}
    >
      <AlertTitle>{severity.toUpperCase()}</AlertTitle>
      <h5>{subHeading}</h5>
      {message}
    </Alert>
  );
  
};
